import { render, staticRenderFns } from "./ProgressoFidelidade.vue?vue&type=template&id=3544124e&scoped=true"
import script from "./ProgressoFidelidade.vue?vue&type=script&lang=js"
export * from "./ProgressoFidelidade.vue?vue&type=script&lang=js"
import style0 from "./ProgressoFidelidade.vue?vue&type=style&index=0&id=3544124e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544124e",
  null
  
)

export default component.exports